<template>
  <div class="transition-loader" :class="{ fullPage }">
    <div class="transition-loader-inner">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fullPage: Boolean,
  },
  data: () => ({
    loading: true,
  }),
  methods: {
    // start() {
    //     this.loading = true;
    // },
    // finish() {
    //     setTimeout(() => { this.loading = false; }, 2000);
    // }
  },
  async mounted() {},
}
</script>

<style lang="scss" scoped>
.transition-loader {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  &.fullPage {
    position: fixed;
    background: #33333350;
    z-index: 1000000;
  }
}

.transition-loader-inner {
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
  position: absolute;
  width: calc(100% - 200px);
  color: #fff;
  padding: 0 100px;
  text-align: center;
  span {
    position: relative;
    padding: 1%;
    height: 20px;
    width: 20px;
    display: inline-block;
    &::before {
      content: '';
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 50%;
      height: 50%;
      background-color: rgb(39, 127, 175);
      border-radius: 50%;
    }
  }
}

$key-frames-ms: 600ms, 500ms, 400ms, 300ms, 200ms, 100ms;

@each $current-ms in $key-frames-ms {
  $i: index($key-frames-ms, $current-ms);
  .transition-loader-inner span:nth-child(#{$i}) {
    -webkit-animation: loader 3s $current-ms infinite ease-in-out;
    animation: loader 3s $current-ms infinite ease-in-out;
  }
}

@keyframes loader {
  0% {
    opacity: 0;
    transform: translateX(-400px) scale(1);
  }
  33% {
    opacity: 1;
    transform: translateX(0px) scale(2);
  }
  66% {
    opacity: 1;
    transform: translateX(0px) scale(1);
  }
  100% {
    opacity: 0;
    transform: translateX(400px) scale(2);
  }
}

@-webkit-keyframes loader {
  0% {
    opacity: 0;
    -webkit-transform: translateX(-400px);
  }
  33% {
    opacity: 1;
    -webkit-transform: translateX(0px);
  }
  66% {
    opacity: 1;
    -webkit-transform: translateX(0px);
  }
  100% {
    opacity: 0;
    -webkit-transform: translateX(400px);
  }
}
</style>
